<template>
  <div class="">
    <div class="essStatus">
      <tl-radio
        name="uploadMethod1"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
      <tl-radio
        name="uploadMethod2"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>
    <div v-if="uploadMethod == 'manualUpload'">
      <div class="row marginbot-20">
        <search-dropdown
          class="col-3"
          label="Select Employee"
          :employeeData="employeeData"
          @empselected="(emp)=>selectedEmp(emp)"
        />
        <tl-select
          class="col-2"
          labelText="name"
          label="Select Month"
          :options="monthList"
          :value="formData.month"
          @change="(val)=>formData.month=val"
        />
      </div>
      <div class="row marginbot-20">
        <tl-select
          class="col-2"
          labelText="name"
          label="Earning head"
          :options="salaryComponentList"
          v-model="formData.earningHeadData"
          @change="(val)=>formData.earningHeadData=val"/>
        <txt
          class="col-2"
          autofocus="autofocus"
          label="Amount Paid"
          type="number"
          v-model="formData.paidAmt"
          placeholder="Enter Amount Paid"
          name="earningHead"
          @onValueChange="save"
        />
        <txt
          class="col-2"
          autofocus="autofocus"
          label="TDS"
          type="number"
          v-model="formData.taxAmt"
          placeholder="Enter Income tax amount"
          name="earningHead"
          @onValueChange="save"
        />
      </div>
      <div class="row marginbot-20">
        <txt
          class="col-6"
          autofocus="autofocus"
          label="Remarks"
          type="textarea"
          rows="6"
          v-model="formData.remarks"
          placeholder="Enter Remarks"
          name="earningHead"
          @onValueChange="save"
        />
      </div>
      <btn class="marginbot-20" text="Add" type="secondary" @click="addEmployee" />
      <div class="row ">
        <div class="col-4 marginbot-20" v-for="(employeedata,index) in selectedEmpList" :key="index">
          <selected-employee-card
                :empName="employeedata.employee.name"
                :empId="employeedata.employee.code"
                :empMail="employeedata.employee.email"
            ></selected-employee-card>
        </div>
      </div>

    </div>
    <div v-else>
      <div class="marginbot-20">
        <download-button/>
      </div>
      <upload/>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`IT remittance successfully submitted.`"
      btnText="Back to IT remittance"
      @back="backfrompopup()"
    />
    <footer>
      <bottom-action-container>
        <btn-grp slot="end">
          <btn text="Back" type="secondary" @click="cancel" />
          <btn text="Submit" type="primary" @click="save"></btn>
        </btn-grp>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
export default {
  components: {
    SearchDropdown,
    SelectedEmployeeCard
  },
  data() {
    return {
      formData: {},
      showCreateModal: false,
      employeeDetails: {},
      search: "",
      manual: true,
      showSuccessMsg: false,
      auto_suggestions: false,
      uploadMethod:'manualUpload',
      selectedEmpList:[],
      legalEntityList: ["HR", "Accountant", "TeamLead"],
      monthList: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      salaryComponentList:['HRA','BASIC','ESI'],
      employeeData: [
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          email:'nellefoster@gmail.com',
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL002",
          name: "Derrick Perry",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          email:'derrick@gmail.com',
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL003",
          name: "Lucas Singleton",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          email:'lukasSigle@gmail.com',
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL004",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          email:'nellefoster@gmail.com',
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          email:'nellefoster@gmail.com',
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        }
      ],
      legalEntitiesData: []
    };
  },
  computed: {
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  mounted() {
    //console.log("New component mounted.");
    //console.log("orgId", this.orgid);
  },
  activated: function() {
    //console.log("activated");
    this.fetchLegalEntities();
  },
  methods: {
    ...mapActions({
      
      fetch: "onboard/legal_entities/fetchAll",
      act_changeEmployeeESSStatus: "dashboard/oganisation/essManagement/create"
    }),
    async fetchLegalEntities() {
      try {
        let response = await this.fetch(this.orgid);
        this.legalEntitiesData = response.data;
        //console.log("legalEntitiesData:", this.legalEntitiesData);
      } catch (err) {
        //console.log("intro error", err);
      }
    },
    addEmployee(){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.selectedEmpList.push(this.formData);
          //console.log('listofemps',this.selectedEmpList);
          this.cancel();
        }
      });
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    },
    cancel() {
      this.formData = {};
    },
    manualEntry() {
      //console.log("manual", this.formData.manual);
      this.manual = true;
    },
    bulkUpload() {
      this.manual = false;
    },

    selectedEmp(emp) {
      //console.log("emp sleected data", emp);
      this.formData['employee'] = emp
    },
    async performAction() {
      try {
        let formDataArray = [];
        formDataArray.push(this.formData);
        this.$root._data.isSaving = true;
        if (this.editMode) {
          await this.act_update([this.formData, this.le_id]);
        } else {
          await this.act_create({
            data: formDataArray,
            le_id: this.le_id
          });
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
        this.refresh();
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async save() {
      //console.log("formData", this.formData);
      this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("perform signup", result);
          this.performAction().then(() => {
            this.showSuccessMsg = true;
          });
        }
      });
    },

    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("Submit", result);
          this.performAction().then(() => {
            this.showSuccessMsg = true;
          });
        }
      });
      this.submitFormData();
    },

    async submitFormData() {
      let obj = {
        emp_id: this.formData.emp_id,
        email_id: this.formData.email
      };
      this.changeESSStatusModal = false;
      //console.log("obj:", obj);

      try {
        let res = await this.act_changeEmployeeESSStatus(obj);
        // let dataArr = res.data.rows;
        // if (dataArr.length){
        //     this.departmentData = res.data;
        // }
        //console.log("saveModalData:", res);
      } catch (err) {
        //console.log(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.nav {
  margin-top: 1.7%;
  color: #555555;
  font-size: 11px;
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.position-fixed {
  position: fixed;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}

.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
}
.half-width {
  width: 26.7%;
}
.search-bar input {
  height: 35px !important;
}
.filters-section {
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
  // overflow: scroll;
  *:not(:last-child) {
    margin-right: 18px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.emp-img {
  width: auto;
  text-align: center;
}
.component-wrapper {
  padding: 14px;
}
.custom-width-100 {
  width: 100px;
}

.selectdiv {
  width: 320px !important;
  .input-label {
    opacity: 0.5 !important;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 30px 0px;
  display: flex;
}
.essStatus {
  margin: 2% 0 2% 0;
  display: flex
}

.sort-by {
  display: flex;
  margin-left: 1%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ht-35 {
  .tl-textfield input,
  select {
    height: 30px !important;
  }
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.group-btn {
  margin: 40px 0px;
}
.search-container {
  width: auto;
}
// .search-bar{
//     position: relative;
// }
.search-result {
  position: absolute;
  width: 320px;
  background: #ffffff;
  max-height: 368px;
  border-radius: 4px;
  border: solid 1px #f7f7f7;
  overflow: auto;
  li {
    padding: 15px;
    border-bottom: 0.5px solid #e3e3e3;
    margin-right: 0px !important;
    &:hover {
      background-color: #d6f2f2;
    }
  }
}
.threeColumnGrid {
  grid-column-gap: 0px;
}
.img-part {
  img {
    width: 100%;
  }
}
</style>
